import {
  GatewayControleQuinquennal,
  GatewayQuestionnaire,
} from "@conformite/gateway";
import { AxeCard } from "@src/components/AssujettiDetailConformite/AxeCard";
import containerStyles from "@src/components/AssujettiDetailConformite/AssujettiDetailConformite.module.scss";

/**
 * Slug LOCAL à cette carte : ne PAS l'ajouter à `axeConformiteToQuestionnaireSlug`
 * ni `axeTypeToQuestionnaireSlug` — leurs copies front + gateway restent sans
 * entrée ASSUJETTI/LISTE (invariant documenté dans liste-assujettis.definition.ts).
 */
const LISTE_ASSUJETTIS_SLUG: GatewayQuestionnaire.QuestionnaireSlug =
  GatewayQuestionnaire.QuestionnaireSlug.cq_assujetti_liste;

// Même contexte d'instance que les questionnaires d'axe société : le
// questionnaire LISTE est porté par l'AXE, pas par une personne.
const CONTEXT_TYPE = "CONTROLE_QUINQUENNAL_AXE";

type ListeAssujettisCardProps = {
  idAxe: string;
  verification?: GatewayControleQuinquennal.ControleQuinquennalSubAxisVerification;
  onRelaunch?: () => void;
  isRelaunching?: boolean;
  disabled?: boolean;
};

export function ListeAssujettisCard({
  idAxe,
  verification,
  onRelaunch,
  isRelaunching,
  disabled,
}: ListeAssujettisCardProps) {
  return (
    <div className={containerStyles.cardContainer}>
      <span className={containerStyles.cardContainerHeader}>
        <h4 className={containerStyles.cardContainerTitle}>
          Liste des personnes assujetties
        </h4>
      </span>
      <div className={containerStyles.cardList}>
        <AxeCard
          axeId="LISTE_ASSUJETTIS"
          label="Cohérence de la liste déclarée"
          slug={LISTE_ASSUJETTIS_SLUG}
          contextType={CONTEXT_TYPE}
          contextId={idAxe}
          stickyTop={0}
          verification={verification}
          onRelaunchVerification={onRelaunch}
          isRelaunchingVerification={isRelaunching}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
